export default "__VITE_ASSET__Dd9Kgr3x__"